import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';
import { isElementVisible } from '@theme/utilities';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (e) => {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      this.close();
    }
  };

  #handleCartAdd = () => {
    this.#closeHiddenDuplicateDrawers();

    if (!this.hasAttribute('auto-open') || !isElementVisible(this)) return;

    // Ensure scroll-lock is maintained when opening cart drawer
    // This is especially important when transitioning from quick-add dialog
    this.showDialog();
  };

  /** Close modal state on duplicate v2 header drawers (desktop/mobile markup). */
  #closeHiddenDuplicateDrawers() {
    document.querySelectorAll('cart-drawer-component').forEach((el) => {
      if (el === this || isElementVisible(el)) return;
      const dialog = el.querySelector('dialog');
      if (dialog instanceof HTMLDialogElement && dialog.open) {
        dialog.close();
      }
    });
  };

  open() {
    this.#closeHiddenDuplicateDrawers();

    if (!isElementVisible(this)) return;

    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
